import api from '../api/axios';
import { Perfil, PerfilInput } from '../types/perfil';

export const perfilService = {
  /** Datos personales del usuario. */
  get: async (): Promise<Perfil> => {
    const { data } = await api.get<Perfil>('me/perfil/');
    return data;
  },

  /** Edita email/alias/foto (multipart para poder subir la foto). */
  update: async (input: PerfilInput): Promise<Perfil> => {
    const fd = new FormData();
    fd.append('email', input.email);
    fd.append('alias', input.alias);
    if (input.foto) fd.append('foto', input.foto);
    const { data } = await api.patch<Perfil>('me/perfil/', fd);
    return data;
  },

  /** Áreas de interés del docente (ids de AreaInvestigacion). */
  updateAreas: async (areas: number[]): Promise<Perfil> => {
    const { data } = await api.patch<Perfil>('me/perfil/', { areas });
    return data;
  },
};
